import React, { Component } from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup,
    StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarContasBancariasDs } from "../../DataSources";

const localStorageKey = "cadastroContaBancariaGridState";

export default class ContasBancariasBox extends Component {
    constructor() {
        super();
        this._gridInstance = React.createRef();
        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("contasbancarias/editar/" + e.data.id);
    }

    render() {
        return (
            <React.Fragment>
                <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="Contas Bancárias" novoCb={this.novaContaBancaria.bind(this)}>
                        <DataGrid
                            ref={grid => this._gridInstance = grid}
                            dataSource={criarContasBancariasDs()}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            remoteOperations={true}
                            columnAutoWidth={true}
                            columnHidingEnabled={true}
                            focusedRowEnabled={true}
                            wordWrapEnabled={window.innerWidth < 800}
                            filterSyncEnabled={true}
                            onEditingStart={this.onAtualizandoRow}>
                            <StateStoring enabled={true} type={'localStorage'} storageKey={localStorageKey} />
                            <FilterRow visible={true} />
                            <Editing allowDeleting={true} allowUpdating={true} mode />
                            <Column dataField={'id'} caption={"#"} allowEditing={false} />
                            <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                                <FormItem visible={false}></FormItem>
                            </Column>
                            <Column dataField={'agenteRecebedorId'} caption={"Agente Recebedor"} />
                            <Column dataField={'agenciaComDv'} caption={"Agência"} />
                            <Column dataField={'contaComDv'} caption={"Conta"} />
                            <Column dataField={'carteira'} caption={"Carteira"} />
                            <Column dataField={'variacaoCarteira'} caption={"Variação da Carteira"} />
                            <Column dataField={'tipoCarteira'} caption={"Tipo da Carteira"} />
                            <Column dataField={'formaCadastramento'} caption={"Forma de Cadastramento"} />
                            <Column dataField={'tipoImpresao'} caption={"Tipo de Impressão"} />
                            <Column dataField={'convenio'} caption={"Convenio"} />
                            <Column dataField={'contrato'} caption={"Contrato"} />
                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    novaContaBancaria() {
        let gridState = this._gridInstance.instance.state();
        localStorage.setItem(localStorageKey, JSON.stringify(gridState));
        this.props.history.push("contasbancarias/novo");
    }
    
}
